import { render, staticRenderFns } from "./ConnectionPracticeNumber.vue?vue&type=template&id=742a5091&scoped=true"
import script from "./ConnectionPracticeNumber.vue?vue&type=script&lang=ts"
export * from "./ConnectionPracticeNumber.vue?vue&type=script&lang=ts"
import style0 from "./ConnectionPracticeNumber.vue?vue&type=style&index=0&id=742a5091&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742a5091",
  null
  
)

export default component.exports